import React, { useCallback, useEffect, useRef, useState } from "react";
import "./CanvaImage.scss";
import getDataFromApi from "../../getDataFromApi";
import Prediction from "./Prediction";
import { CloseIcon, ImagesIcon, LabelsIcon } from "../../../views/Common/SvgIcons/WorkflowIcons";
import { faPlus, faSearch, faTags, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorBanner from "../../../views/Common/Errors/ErrorBanner";
import { Skeleton } from "@mui/material";
import { StyledTooltip } from "../../../views/project/label/annotation/EditorView/EditorTopNavigationBar/EditorTopNavigationBar";
import { ReactStrapModal } from "../../reactstrap_modal/ReactStrapModal";
import Confirm from "../../confirm/Confirm";
import GenerateTaskCollection from "../../../views/project/data/generate_task_collection/GenerateTaskCollection";
import AlertComponent from "../../alert/AlertComponent";
import { alertContext } from "../ModalComponent";
import { loadRenderableImageSource } from "./dicomImage";

/* -------------------------------------------------------
   Canvas Component (draw image + bounding boxes)
-------------------------------------------------------- */


// export const ImageCanvas = ({ img, onLoad, onClick, modelName, isModal = false }) => {
//   const canvasRef = useRef(null);

//   const capitalizeFirst = (s = "") => {
//     const str = String(s).trim();
//     if (!str) return "";
//     return str.charAt(0).toUpperCase() + str.slice(1);
//   };

//   useEffect(() => {
//     if (!img?.url) return;
//     const canvas = canvasRef.current;
//     if (!canvas) return;

//     const ctx = canvas.getContext("2d");
//     const image = new Image();
//     image.src = img.url;

//     let boxes = [];        // scaled boxes
//     let hoverIndex = null; // which box is hovered

//     image.onload = () => {
//       onLoad?.();
//       const wrapper = canvas.parentElement;
//       // const containerWidth = wrapper.getBoundingClientRect().width;
//       let containerWidth;

//       if (isModal) {
//         containerWidth = Math.min(window.innerWidth * 0.9, image.width);
//       } else {
//         containerWidth = wrapper?.getBoundingClientRect()?.width;
//       }

//       const scale = containerWidth / image.width;
//       const displayWidth = containerWidth;
//       const displayHeight = image.height * scale;

//       canvas.width = displayWidth;
//       canvas.height = displayHeight;

//       // Draw function
//       const draw = () => {
//         ctx.clearRect(0, 0, canvas.width, canvas.height);
//         ctx.drawImage(image, 0, 0, displayWidth, displayHeight);

//         // Draw boxes if present
//         if (Array.isArray(img.boxes)) {
//           img?.boxes?.forEach((b, index) => {
//             let [bx, by, bw, bh, label, color] = b;

//             // Normalize
//             if (bx <= 1 && by <= 1 && bw <= 1 && bh <= 1) {
//               bx *= image.width;
//               by *= image.height;
//               bw *= image.width;
//               bh *= image.height;
//             }

//             // Scale
//             const x = bx * (displayWidth / image.width);
//             const y = by * (displayHeight / image.height);
//             const w = bw * (displayWidth / image.width);
//             const h = bh * (displayHeight / image.height);

//             boxes[index] = { x, y, w, h, label, color };

//             // Outline
//             ctx.lineWidth = Math.max(1, displayWidth * 0.003);
//             ctx.strokeStyle = color || "#ff3838";
//             ctx.strokeRect(x, y, w, h);

//             // Fill ONLY when hovered
//             if (index === hoverIndex && modelName !== "owlvit") {
//               ctx.globalAlpha = 0.25;
//               ctx.fillStyle = color || "#ff3838";
//               ctx.fillRect(x, y, w, h);
//               ctx.globalAlpha = 1;
//             }
//             const labelText = capitalizeFirst(label);

//             // Draw label only if text exists
//             if (labelText) {
//               ctx.font = "bold 12px Montserrat";
//               const pad = 5;
//               const tw = ctx.measureText(labelText).width;
//               const th = 12;

//               ctx.fillStyle = color || "#ff3838";
//               ctx.fillRect(x, y - (th + pad), tw + pad * 2, th + pad);

//               ctx.fillStyle = "#fff";
//               ctx.fillText(labelText, x + pad, y - pad);
//             }
//           });
//         }

//         // Draw landmarks if present
//         if (Array.isArray(img.landmarks)) {
//           img?.landmarks?.forEach((landmarkGroup) => {
//             landmarkGroup.forEach((landmark) => {
//               const [x, y] = landmark;  // Destructure the array to get x and y coordinates

//               // Debugging step: Log x, y, image.width, and displayWidth
//               // console.log('x:', x, 'y:', y, 'image.width:', image.width, 'displayWidth:', displayWidth);

//               // Check if x, y, image.width, and displayWidth are valid numbers
//               if (isNaN(x) || isNaN(y) || isNaN(image.width) || isNaN(displayWidth)) {
//                 console.error('Invalid value detected, skipping this landmark.');
//                 return;  // Skip this landmark if invalid
//               }

//               // Normalize coordinates to the canvas size
//               if (x <= 1 && y <= 1) {
//                 // Assuming the landmarks are normalized between 0 and 1
//                 x *= image.width;
//                 y *= image.height;
//               }

//               // Scale the coordinates based on the canvas size
//               const scaledX = x * (displayWidth / image.width);
//               const scaledY = y * (displayHeight / image.height);

//               // Debugging step: Log the scaled coordinates
//               console.log('scaledX:', scaledX, 'scaledY:', scaledY);

//               // Draw each landmark as a circle
//               ctx.beginPath();
//               ctx.arc(scaledX, scaledY, 5, 0, 2 * Math.PI); // Radius of 5px
//               ctx.fillStyle = "red"; // Landmark color
//               ctx.fill();
//             });
//           });
//         }


//       };

//       draw();

//       // Hover handler
//       const onMove = (e) => {
//         const rect = canvas.getBoundingClientRect();
//         const mx = e.clientX - rect.left;
//         const my = e.clientY - rect.top;

//         let found = null;

//         boxes?.forEach((box, i) => {
//           if (mx >= box.x && mx <= box.x + box.w &&
//             my >= box.y && my <= box.y + box.h) {
//             found = i;
//           }
//         });

//         if (found !== hoverIndex) {
//           hoverIndex = found;
//           draw();
//         }
//       };

//       const onLeave = () => {
//         hoverIndex = null;
//         draw();
//       };

//       canvas.addEventListener("mousemove", onMove);
//       canvas.addEventListener("mouseleave", onLeave);

//       return () => {
//         canvas.removeEventListener("mousemove", onMove);
//         canvas.removeEventListener("mouseleave", onLeave);
//       };
//     };
//   }, [img]);

//   return <canvas ref={canvasRef} className="canva-canvas" onClick={onClick} />;
// };


export const ImageCanvas = ({ img, onLoad, onClick, modelName, isModal = false }) => {
  const canvasRef = useRef(null);

  const capitalizeFirst = (s = "") => {
    const str = String(s).trim();
    if (!str) return "";
    return str;
  };

  useEffect(() => {
    if (!img?.url) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const image = new Image();
    let cancelled = false;

    let boxes = [];
    let hoverIndex = null;
    let cleanup = null;

    image.onload = () => {
      if (cancelled) return;
      onLoad?.();

      const wrapper = canvas.parentElement;
      let containerWidth;

      if (isModal) {
        containerWidth = Math.min(window.innerWidth * 0.9, image.width);
      } else {
        containerWidth = wrapper?.getBoundingClientRect()?.width || image.width;
      }

      const sourceWidth = img.sourceWidth || image.width;
      const sourceHeight = img.sourceHeight || image.height;
      const scale = containerWidth / image.width;
      const displayWidth = containerWidth;
      const displayHeight = image.height * scale;

      canvas.width = displayWidth;
      canvas.height = displayHeight;

      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

      const drawLabel = ({
        x,
        y,
        w,
        h,
        color,
        text
      }) => {
        if (!text) return;

        const fontSize = Math.max(11, Math.min(16, displayWidth * 0.018));
        const padX = 3;
        const padY = 4;
        const boxH = fontSize + padY * 2;

        ctx.font = `bold ${fontSize}px sans-serif`;
        const textW = ctx.measureText(text).width;
        const boxW = textW + padX * 2;

        let labelX = x;
        let labelY = y - boxH - 2;

        const tooTop = labelY < 0;
        const tooRight = labelX + boxW > displayWidth;
        const tooLeft = labelX < 0;


        if (tooTop) {
          labelY = y + 2;
        }


        if (tooRight) {
          labelX = displayWidth - boxW - 2;
        }
        if (tooLeft) {
          labelX = 2;
        }


        if (labelX < x && x + w - boxW >= 0) {
          labelX = x + w - boxW;
        }

        labelX = clamp(labelX, 2, Math.max(2, displayWidth - boxW - 2));


        if (labelY + boxH > displayHeight) {
          labelY = Math.max(2, y - boxH - 2);
        }

        ctx.fillStyle = color || "#ff3838";
        ctx.fillRect(labelX, labelY, boxW, boxH);

        ctx.fillStyle = "#fff";
        ctx.textBaseline = "top";
        ctx.fillText(text, labelX + padX, labelY + padY);
      };

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0, displayWidth, displayHeight);

        if (Array.isArray(img.boxes)) {
          img.boxes.forEach((b, index) => {
            let [bx, by, bw, bh, label, color] = b;

            if (
              typeof bx !== "number" ||
              typeof by !== "number" ||
              typeof bw !== "number" ||
              typeof bh !== "number"
            ) {
              return;
            }


            if (bx <= 1 && by <= 1 && bw <= 1 && bh <= 1) {
              bx *= sourceWidth;
              by *= sourceHeight;
              bw *= sourceWidth;
              bh *= sourceHeight;
            }

            const x = bx * (displayWidth / sourceWidth);
            const y = by * (displayHeight / sourceHeight);
            const w = bw * (displayWidth / sourceWidth);
            const h = bh * (displayHeight / sourceHeight);

            boxes[index] = { x, y, w, h, label, color };

            ctx.lineWidth = Math.max(1, displayWidth * 0.003);
            ctx.strokeStyle = color || "#ff3838";
            ctx.strokeRect(x, y, w, h);

            if (index === hoverIndex && modelName !== "owlvit") {
              ctx.globalAlpha = 0.25;
              ctx.fillStyle = color || "#ff3838";
              ctx.fillRect(x, y, w, h);
              ctx.globalAlpha = 1;
            }

            const labelText = capitalizeFirst(label);

            if (labelText) {
              drawLabel({
                x,
                y,
                w,
                h,
                color,
                text: labelText
              });
            }

            // score for current box
            const rawScore = Array.isArray(img.score) ? img.score[index] : undefined;
            const scoreText =
              rawScore !== undefined && rawScore !== null && !Number.isNaN(Number(rawScore))
                ? Number(rawScore).toFixed(4)
                : "";

            if (scoreText) {
              drawLabel({
                x,
                y: labelText ? y + 22 : y,
                w,
                h,
                color: "red",
                text: scoreText
              });
            }
          });
        }

        if (Array.isArray(img.landmarks)) {
          img.landmarks.forEach((landmarkGroup) => {
            landmarkGroup.forEach((landmark) => {
              let [x, y] = landmark;

              if (isNaN(x) || isNaN(y) || isNaN(image.width) || isNaN(displayWidth)) {
                return;
              }

              if (x <= 1 && y <= 1) {
                x *= image.width;
                y *= image.height;
              }

              const scaledX = x * (displayWidth / image.width);
              const scaledY = y * (displayHeight / image.height);

              ctx.beginPath();
              ctx.arc(scaledX, scaledY, 5, 0, 2 * Math.PI);
              ctx.fillStyle = "red";
              ctx.fill();
            });
          });
        }
      };

      draw();

      const onMove = (e) => {
        const rect = canvas.getBoundingClientRect();
        const mx = e.clientX - rect.left;
        const my = e.clientY - rect.top;

        let found = null;

        boxes.forEach((box, i) => {
          if (
            mx >= box.x &&
            mx <= box.x + box.w &&
            my >= box.y &&
            my <= box.y + box.h
          ) {
            found = i;
          }
        });

        if (found !== hoverIndex) {
          hoverIndex = found;
          draw();
        }
      };

      const onLeave = () => {
        hoverIndex = null;
        draw();
      };

      canvas.addEventListener("mousemove", onMove);
      canvas.addEventListener("mouseleave", onLeave);

      cleanup = () => {
        canvas.removeEventListener("mousemove", onMove);
        canvas.removeEventListener("mouseleave", onLeave);
      };
    };

    loadRenderableImageSource(img.url)
      .then((source) => {
        if (!cancelled) image.src = source;
      })
      .catch((error) => {
        if (!cancelled) {
          console.error("Unable to render DICOM image", error);
          onLoad?.();
        }
      });

    return () => {
      cancelled = true;
      cleanup?.();
      image.onload = null;
    };
  }, [img, modelName, isModal, onLoad]);

  return <canvas ref={canvasRef} className="canva-canvas" onClick={onClick} />;
};

const mergeLabels = (previousLabels = [], nextLabels = []) => {
  const seen = new Set();

  return [...previousLabels, ...nextLabels].filter((label) => {
    const key = JSON.stringify(label);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const mergePredictionPages = (previous, next) => ({
  ...(previous || {}),
  ...(next || {}),
  annotations: {
    ...(previous?.annotations || {}),
    ...(next?.annotations || {}),
  },
  labels: mergeLabels(previous?.labels, next?.labels),
});

const formatImageItems = (annotations = {}, startIndex = 0) =>
  Object.values(annotations).map((item, idx) => ({
    id: startIndex + idx,
    name: item.image_name,
    tag: item.tags?.[0],
    url: item.image_url,
    boxes: item.ground_truth,
    width: Number(item.img_width),
    height: Number(item.img_height),
  }));


/* -------------------------------------------------------
   Main Component
-------------------------------------------------------- */
const DATA_SAMPLE_PAGE_SIZE = 25;

const buildPaginationItems = (currentPage, pageCount) => {
  if (pageCount <= 12) {
    return Array.from({ length: pageCount }, (_, index) => index + 1);
  }

  const pages = new Set([1, 2, 3, 4, pageCount - 1, pageCount]);

  for (let pageNumber = currentPage - 2; pageNumber <= currentPage + 2; pageNumber += 1) {
    if (pageNumber >= 1 && pageNumber <= pageCount) pages.add(pageNumber);
  }

  const sortedPages = Array.from(pages).sort((first, second) => first - second);

  return sortedPages.reduce((items, pageNumber, index) => {
    if (index > 0 && pageNumber - sortedPages[index - 1] > 1) items.push("…");
    items.push(pageNumber);
    return items;
  }, []);
};

export default function CanvaImage({ datasetId, parentDatasetId, onImagesChanged ,project_type}) {
  const [items, setItems] = useState([]);
  const [predictionData, setPredictionData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [Data, setData] = useState(false);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageInput, setPageInput] = useState("1");
  const [pageTransition, setPageTransition] = useState(null);
  const gridRef = useRef(null);


  // Dataset meta
  const [datasetName, setDatasetName] = useState("");
  const [datasetVersion, setDatasetVersion] = useState("");
  const [imageCount, setImageCount] = useState({
    Train: 0,
    Test: 0,
    Val: 0,
  });
  const [emptyTagMsg, setEmptyTagMsg] = useState("");

  // Filters
  const [search, setSearch] = useState("");
  const [selectedTag, setSelectedTag] = useState("All");
  const [trigger, setTrigger] = useState(0);

  // Grid size
  const [gridSize, setGridSize] = useState(120);

  // Selection
  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [form, setFormName] = useState("");
  const [drawerMode, setDrawerMode] = useState("");
  const [datasetDeleteUrl, setDatasetDeleteUrl] = useState();
  const [drawerAlert, setDrawerAlert] = useState();
  const normalizedDrawerAlert =
    typeof drawerAlert === "string"
      ? { message: drawerAlert, status: "error" }
      : drawerAlert;

  /* -------------------------------------------------------
     Fetch API
  -------------------------------------------------------- */
  const fetchImagesPage = useCallback(async (pageNumber, transitionDirection = null) => {
    if (!datasetId) return;

    if (transitionDirection) {
      setPageTransition(transitionDirection);
    } else {
      setLoading(true);
      setItems([]);
      setPredictionData();
    }
    setError(null);

    const pageUrl = `${window["ENV"].API_URL}/dataset_versions/detailed/${datasetId}/images?page_number=${pageNumber}&page_size=${DATA_SAMPLE_PAGE_SIZE}&tag=${encodeURIComponent(selectedTag)}`;

    try {
      const data = await getDataFromApi(pageUrl, "GET");

      if (!data) {
        setError({
          status: 500,
          type: "API",
          message: "Empty response from server.",
        });
        return;
      }

      if (data.detail) {
        setError({
          status: data.status_code ?? data.status ?? 400,
          type: "API",
          message: data.detail,
        });
        if (!transitionDirection) {
          setItems([]);
          setPredictionData();
        }
        return;
      }

      setDatasetName(data.dataset_name || "Dataset");
      setDatasetVersion(data.dataset_version || "1.0");

      const split = data.data_split || {};
      setImageCount({
        Train: split.train ?? 0,
        Test: split.test ?? 0,
        Val: split.val ?? 0,
      });

      const nextAnnotations = data.annotations || {};
      setTotalPages(Number(data.page_count) || 1);
      setPage(Number(data.active_page) || pageNumber);
      setPredictionData(data);

      setItems(
        formatImageItems(
          nextAnnotations,
          (Number(data.active_page) || pageNumber) > 1
            ? (Number(data.active_page) - 1) * DATA_SAMPLE_PAGE_SIZE
            : 0
        )
      );
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
      setPageTransition(null);
    }
  }, [datasetId, selectedTag]);

  useEffect(() => {
    setItems([]);
    setPredictionData();
    setPage(1);
    setTotalPages(1);
    setPageInput("1");
    setPageTransition(null);
    fetchImagesPage(1);
  }, [fetchImagesPage, trigger]);

  useEffect(() => {
    setPageInput(String(page));
  }, [page]);

  const hasPreviousPage = page > 1;
  const hasNextPage = page < totalPages;
  const isPageFetching = Boolean(pageTransition);
  const showPagination = totalPages > 1 || hasPreviousPage || hasNextPage;
  const paginationItems = buildPaginationItems(page, totalPages);

  const goToPage = (nextPage) => {
    if (isPageFetching || nextPage < 1 || nextPage > totalPages) return;
    if (nextPage === page) return;
    fetchImagesPage(nextPage, nextPage > page ? "next" : "prev");
  };

  const submitPageInput = () => {
    const requestedPage = Number(pageInput);

    if (!Number.isInteger(requestedPage)) return;
    goToPage(requestedPage);
  };

  useEffect(() => {
    setSelected([]);
    setSelectAll(false);
    setFormName("");
    setDrawerMode("");
    setDatasetDeleteUrl();
  }, [datasetId]);

  /* -------------------------------------------------------
     Select All
  -------------------------------------------------------- */
  const toggleSelectAll = () => {
    if (!selectAll) setSelected(items.map((i) => i.name));
    else setSelected([]);
    setSelectAll((s) => !s);
  };


  /* -------------------------------------------------------
     Filtering
  -------------------------------------------------------- */
  const filtered = items.filter((img) => {
    const lower = search.toLowerCase();
    const nameMatch = img.name.toLowerCase().includes(lower);
    const labelMatch = img.boxes?.some((b) =>
      String(b[4]).toLowerCase().includes(lower)
    );
    return nameMatch || labelMatch;
  });

  const noSearchResults =
    !loading &&
    items.length > 0 &&
    search.trim().length > 0 &&
    filtered.length === 0;



  const refetch = useCallback(() => {
    setTrigger((prev) => prev + 1);
  }, []);

  const selectedCount = selected.length;
  const canEditSelectedTag = selectedTag !== "All";
  const transformEditTagSchema = useCallback((schemaData) => {
    const fieldName = "Update Tag";
    const fieldSchema = schemaData?.json_schema?.properties?.[fieldName];

    if (!canEditSelectedTag || !Array.isArray(fieldSchema?.enum)) {
      return schemaData;
    }

    const allowedOptions = fieldSchema.enum
      .map((value, index) => ({ value, index }))
      .filter(({ value }) => value !== selectedTag);

    const nextFieldSchema = {
      ...fieldSchema,
      enum: allowedOptions.map(({ value }) => value),
    };

    if (Array.isArray(fieldSchema.enumNames)) {
      nextFieldSchema.enumNames = allowedOptions.map(
        ({ index }) => fieldSchema.enumNames[index]
      );
    }

    if (!nextFieldSchema.enum.includes(fieldSchema.default)) {
      delete nextFieldSchema.default;
    }

    return {
      ...schemaData,
      json_schema: {
        ...schemaData.json_schema,
        properties: {
          ...schemaData.json_schema.properties,
          [fieldName]: nextFieldSchema,
        },
      },
    };
  }, [canEditSelectedTag, selectedTag]);

  const handleImageSelection = (imageName) => {
    setSelected((prev) =>
      prev.includes(imageName)
        ? prev.filter((name) => name !== imageName)
        : [...prev, imageName]
    );
  };

  const clearSelectedImages = () => {
    setSelected([]);
    setSelectAll(false);
  };

  const handleActionComplete = () => {
    clearSelectedImages();
    refetch();
    onImagesChanged?.();
  };

  const handleDeleteComplete = () => {
    setDatasetDeleteUrl();
    handleActionComplete();
  };

  const closeActionDrawer = useCallback(() => {
    setFormName("");
    setDrawerMode("");
    setDrawerAlert();
  }, []);

  const setTaskDrawerOpen = useCallback((value) => {
    if (value) {
      setDrawerMode(value);
      return;
    }

    closeActionDrawer();
  }, [closeActionDrawer]);

  const handleformfields = (type) => {
    if (!selectedCount) return;
    if (type === "Edit Tag" && !canEditSelectedTag) return;

    const formSettings = {
      "Edit Tag": {
        formName: `forms/edit_tag/${datasetId}?visual_inspection=false`,
        drawerMode: "Edit Tag",
      },
      "Task": {
        drawerMode: "Task",
      },
    };

    const settings = formSettings[type];
    if (!settings) return;

    setFormName(settings.formName || "");
    setDrawerMode(settings.drawerMode);
  };

  const handleDeleteImages = () => {
    if (!selectedCount) return;

    setDatasetDeleteUrl(
      `${window["ENV"].API_URL}/dataset_versions/images/${datasetId}?confirm=`
    );
  };


  /* -------------------------------------------------------
     UI States
  -------------------------------------------------------- */
  if (loading && items.length === 0)
    return (
      <div
        className={`canva-grid ${datasetId && 'd-grid'}`}
        style={{
          gridTemplateColumns: `repeat(auto-fill, minmax(${150}px, 1fr))`,
        }}
      >
        {[...Array(27)].map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            height={110}
          />
        ))}
      </div>
    );

  // HARD ERROR (network / server / API-level)
  if (error) {
    let title = "Failed to load sample images";
    let description =
      error.message ||
      "Something went wrong while loading sample images. Please try again.";

    if (error.type === "NETWORK" || error.status === 0) {
      title = "Network error";
      description =
        "Unable to reach the server. Please check your internet connection and try again.";
    } else if (error.status === 404) {
      title = "Images not found";
      description =
        error.message ||
        "We couldn’t find any sample images for this dataset version.";
    } else if (error.status === 401 || error.status === 403) {
      title = "Access denied";
      description =
        error.message ||
        "You do not have permission to view these sample images.";
    } else if (error.status >= 500) {
      title = "Server error";
      description =
        error.message ||
        "The server encountered an error while loading sample images. Please try again later.";
    }

    return (
      <ErrorBanner
        title={title}
        description={description}
        onRetry={refetch}
      />
    );
  }


  // API OK but no images  
  if (!items.length) {
    return (
      <div className="d-flex justify-content-center mt-4">
        <div className="p-4 text-center">
          <h6 className="fw-semibold">No sample images available</h6>
          <p className="text-secondary mb-0">
            This dataset version has no uploaded images.
          </p>
          <span className="text-secondary">
            Try uploading images
          </span>
          <br />

          <div className="mt-3 d-j-a gap-2">
            <button
              className="btn btn-primary btn-sm btn-click"
              onClick={refetch}
            >
              Refresh
            </button>
          </div>

        </div>
      </div>
    );
  }

  return (
    <>
      <div className="dataset-sample-images">
      {/* Toolbar */}
      <div className="dataset-sample-images__toolbar d-a w-100 justify-content-between flex-wrap gap-3 mb-3 mt-0" style={{minHeight:'38px'}}>
        <div className="d-a gap-2">
          <ImagesIcon className="wf-icon rounded" />
          <h6 className="mb-0">Sample Images</h6>
          {selectedCount > 0 && (
            <div className="sample-selection-actions">
              <span className="sample-selection-count">
                {selectedCount} selected
              </span>

              {canEditSelectedTag && (
                <StyledTooltip title="Edit Tag">
                  <button
                    type="button"
                    className="sample-selection-button"
                    onClick={() => handleformfields("Edit Tag")}
                    aria-label="Edit tag for selected images"
                  >
                    <FontAwesomeIcon icon={faTags} />
                  </button>
                </StyledTooltip>
              )}

              {project_type !== "Data Management" && (
                <StyledTooltip title="Create Task">
                  <button
                    type="button"
                    className="sample-selection-button"
                    onClick={() => handleformfields("Task")}
                    aria-label="Create task with selected images"
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </button>
                </StyledTooltip>
              )}

              <StyledTooltip title="Delete Images">
                <button
                  type="button"
                  className="sample-selection-button sample-selection-button--danger"
                  onClick={handleDeleteImages}
                  aria-label="Delete selected images"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </StyledTooltip>

              <StyledTooltip title="Clear Selection">
                <button
                  type="button"
                  className="sample-selection-button sample-selection-button--muted"
                  onClick={clearSelectedImages}
                  aria-label="Clear selected images"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </StyledTooltip>
            </div>
          )}
        </div>


        <div className="d-flex gap-2 btn-full-width">
          <select
            className="tag-select sample-tag-select badge-border text"
            style={{ width: "100px" }}
            value={selectedTag}
            onChange={(e) => {
              setSelectedTag(e.target.value);
              clearSelectedImages();
            }}
          >
            <option value="All">
              All ({(imageCount.Train || 0) + (imageCount.Test || 0) + (imageCount.Val || 0)})
            </option>

            <option value="Train" disabled={imageCount.Train === 0}>
              Train ({imageCount.Train})
            </option>

            <option value="Test" disabled={imageCount.Test === 0}>
              Test ({imageCount.Test})
            </option>

            <option value="Val" disabled={imageCount.Val === 0}>
              Val ({imageCount.Val})
            </option>
          </select>


          <div className="d-a container-card px-3 py-1 rounded btn-full-width bg-transparent">
            <FontAwesomeIcon
              className="plain-button2 text-secondary"
              icon={faSearch}
              style={{
                position: "relative",
                opacity: "0.8",
              }}
            />
            <input
              type="text"
              className="search-1 bg-transparent"
              placeholder="Search by name or label..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Grid */}
      {noSearchResults ? (
        <div className="d-flex flex-column align-items-center justify-content-center w-100 py-5">
          <div style={{ fontSize: "3rem" }}>🔍</div>
          <h5 className="fw-semibold mb-2">No matching images found</h5>
          <p className="text-secondary mb-3 text-center" style={{ maxWidth: "450px" }}>
            Try adjusting your search. You can search by image name or label.
          </p>

          <button
            className="btn btn-primary btn-sm btn-click"
            onClick={() => setSearch("")}
          >
            Clear Search
          </button>
        </div>
      ) : (
        <div
          className={`canva-grid p-0 ${datasetId && 'd-grid'} position-relative`}
          ref={gridRef}
          style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(${130}px, 1fr))`,
          }}
        >
          {filtered.map((img) => (
            <div
              key={img.id}
              className="canva-card badge-border"
              onClick={() => {
                const pageLocalIndex = Math.max(
                  0,
                  items.findIndex((item) => item.name === img.name)
                );
                setSliderIndex(pageLocalIndex);
                setData(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <input
                type="checkbox"
                className="canva-checkbox"
                onClick={(e) => e.stopPropagation()}
                checked={selected.includes(img.name)}
                onChange={() => handleImageSelection(img.name)}
              />

              {selectedTag === 'All' && img.tag && (
                <div
                  className="shadow fw-bold"
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    padding: "4px 8px",
                    borderRadius: 6,
                    fontSize: 12,
                    background:
                      img.tag === 'Train'
                        ? 'rgb(51 102 255 / 30%)'
                        : img.tag === 'Test'
                          ? 'rgb(0 0 139 / 40%)'
                          : 'rgb(173 216 230 / 40%)',
                    color: "white",
                    pointerEvents: "none",
                    zIndex: 1,
                  }}
                  title={img.tag}
                >
                  {img.tag}
                </div>
              )}

              <div className="canva-wrapper">
                {/* overlay container */}
                <div style={{ position: "relative" }}>
                  <ImageCanvas img={img} gridSize={gridSize} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showPagination && !noSearchResults && (
        <div className="dataset-sample-pagination" aria-label="Sample images pagination">
          <div className="dataset-sample-pagination__controls">
            <div className="dataset-sample-pagination__pages">
              {paginationItems.map((item, index) =>
                item === "…" ? (
                  <span className="dataset-sample-pagination__ellipsis" key={`ellipsis-${index}`}>
                    …
                  </span>
                ) : (
                  <button
                    type="button"
                    className={`dataset-sample-pagination__page ${item === page ? "is-active" : ""}`}
                    key={item}
                    onClick={() => goToPage(item)}
                    disabled={isPageFetching || item === page}
                    aria-current={item === page ? "page" : undefined}
                    aria-label={`Go to sample images page ${item}`}
                  >
                    {item}
                  </button>
                )
              )}
            </div>

            <div className="dataset-sample-pagination__go">
              <input
                className="dataset-sample-pagination__input text"
                value={pageInput}
                onChange={(event) => setPageInput(event.target.value.replace(/[^\d]/g, ""))}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    submitPageInput();
                  }
                }}
                disabled={isPageFetching}
                inputMode="numeric"
                aria-label={`Page number, from 1 to ${totalPages}`}
                placeholder="Page"
              />
              <button
                type="button"
                className="dataset-sample-pagination__go-button"
                onClick={submitPageInput}
                disabled={
                  isPageFetching ||
                  !Number.isInteger(Number(pageInput)) ||
                  Number(pageInput) < 1 ||
                  Number(pageInput) > totalPages ||
                  Number(pageInput) === page
                }
              >
                GO
              </button>
            </div>
          </div>
        </div>
      )}
      </div>


      {Data && (
        <div
          className={`sample-bg mt-0 mt-md-4  zindex-sm-view`}
          style={{
            position: "fixed",
            top: "1",
          }}
        // onClick={() => setPredictions(false)}
        >
          <div
            className='modal-905 w-100 mx-0 mb-0'
            onClick={(e) => e.stopPropagation()}
          >
            <Prediction
              id={datasetId}
              type="dataset_versions"
              filter="dataset_version"
              preview={false}
              datasetName={datasetName}
              datasetVersion={datasetVersion}
              initialTag={selectedTag}
              sliderIndex={sliderIndex}
              setSliderIndex={setSliderIndex}
              datasetId={parentDatasetId || datasetId}
              visibleCanvas={false}
              initialPredictionData={predictionData}
              initialPage={page}
              initialTotalPages={totalPages}
              pageSize={DATA_SAMPLE_PAGE_SIZE}
              loadDetailPage={(nextPage) =>
                getDataFromApi(
                  `${window["ENV"].API_URL}/dataset_versions/detailed/${datasetId}/images?page_number=${nextPage}&page_size=${DATA_SAMPLE_PAGE_SIZE}&tag=${encodeURIComponent(selectedTag)}`,
                  "GET"
                )
              }
              onDetailPageSync={({ page: nextPage, data, index: nextIndex }) => {
                const resolvedPage = Number(nextPage) || page;
                setPage(resolvedPage);
                if (data?.page_count) {
                  setTotalPages(Number(data.page_count) || 1);
                }
                setPredictionData(data);
                setItems(
                  formatImageItems(
                    data?.annotations || {},
                    resolvedPage > 1
                      ? (resolvedPage - 1) * DATA_SAMPLE_PAGE_SIZE
                      : 0
                  )
                );
                setSliderIndex(Number.isInteger(nextIndex) ? nextIndex : null);
              }}
              setPredictions={setData}
            />
          </div>
        </div>
      )}

      {drawerMode && (
        <div className="canva-action-drawer-overlay" onClick={closeActionDrawer}>
          <div
            className="canva-action-drawer-panel p-0 side-pop-height-mb"
            onClick={(e) => e.stopPropagation()}
          >
            <alertContext.Provider value={setDrawerAlert}>
              <AlertComponent alert={normalizedDrawerAlert} />

              {drawerMode === "Edit Tag" && (
                <div className="canva-inline-form h-100 d-flex flex-column">
                  <header className="canva-inline-form__header">
                    <div className="d-flex gap-2 align-items-start">
                      <LabelsIcon className="wf-icon-blue bg-primary text-white" />
                      <div>
                        <h2 className="canva-inline-form__title mb-0">Edit Tag</h2>
                        <p className="canva-inline-form__subtitle mb-0">
                          {selectedCount} selected image{selectedCount === 1 ? "" : "s"}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="plain-button2 p-0"
                      onClick={closeActionDrawer}
                      aria-label="Close edit tag form"
                    >
                      <CloseIcon className="wf-icon text-secondary text" />
                    </button>
                  </header>

                  <div className="canva-inline-form__body">
                    <ReactStrapModal
                      open={form?.length > 0}
                      close={closeActionDrawer}
                      path={form}
                      images={selected}
                      inline
                      transformSchemaData={transformEditTagSchema}
                      onSubmit={handleActionComplete}
                    />
                  </div>
                </div>
              )}

              {drawerMode === "Task" && (
                <GenerateTaskCollection
                  setOpenModal={setTaskDrawerOpen}
                  onSuccess={() => {
                    handleActionComplete();
                    closeActionDrawer();
                  }}
                  version_id={datasetId}
                  datasetId={parentDatasetId}
                  images={selected}
                  selectedByImages={selectedCount > 0}
                />
              )}
            </alertContext.Provider>
          </div>
        </div>
      )}

      {datasetDeleteUrl && (
        <Confirm
          url={datasetDeleteUrl}
          close={() => setDatasetDeleteUrl()}
          images={selected}
          reload={handleDeleteComplete}
        />
      )}


    </>
  );
}
